export const MAX_MB = 40;
export const MAX_MP = 100;

const dims = (file) => new Promise((resolve) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { resolve({ w: img.naturalWidth, h: img.naturalHeight }); URL.revokeObjectURL(url); };
  img.onerror = () => { resolve(null); URL.revokeObjectURL(url); };
  img.src = url;
});

// Returns a translated message when the file breaks a limit, otherwise null (server re-checks anyway)
export async function fileIssue(file, t) {
  const name = file.name.length > 40 ? `${file.name.slice(0, 37)}…` : file.name;
  if (file.size > MAX_MB * 1024 * 1024) return t("tool.tooBig", { name, mb: (file.size / 1048576).toFixed(1) });
  if (!file.type.startsWith("image/") || /tiff/i.test(file.type)) return null;
  const d = await dims(file);
  if (d && d.w * d.h > MAX_MP * 1e6) return t("tool.tooManyPixels", { name, mp: Math.round(d.w * d.h / 1e6), w: d.w, h: d.h });
  return null;
}
